import { Component } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { PaymentMethodService } from '../crud-service';
import { PaymentMethodCrudIndex } from './crud-index';

@Component({
  selector: 'app-payment-method-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [PaymentMethodService],
})
export class PaymentMethodIndexComponent extends PaymentMethodCrudIndex {
  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
  ];
}
